import { createRoute, redirect, Outlet } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { isAuthenticated } from '@/features/auth';

function AuthedLayoutComponent() {
  return <Outlet />;
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authed',
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/' });
    }
  },
  component: AuthedLayoutComponent,
});
